/**
 * Maps care types to their corresponding profile creation routes
 */
const careTypeToProfilePathMap: Record<string, string> = {
  babysitter: '/sitter/signup/profile/steps',
  nanny: '/sitter/signup/profile/steps',
  pet_care: '/sitter/signup/profile/pet-care',
  companion_care: '/sitter/signup/profile/companion-care',
  housekeeping: '/sitter/signup/profile/housekeeping',
};

/**
 * Returns a route object for creating a new provider profile of the specified care type
 * @param careType - The care type in snake_case (e.g., 'pet_care', 'companion_care')
 * @returns A route object with path and query parameters for profile creation
 */
function getNewProfileRoute(careType: string): { path: string; query: { additionalProfile: string; careType: string } } {
  return {
    path: careTypeToProfilePathMap[careType] || '/sitter/signup/profile/steps',
    query: {
      additionalProfile: 'true',
      careType,
    },
  };
}

export default getNewProfileRoute;
